<template>
  <div class="cardsales-agreements">
    <ValidationProvider
      v-slot="{ errors }"
      name="check"
      :vid="`check-${inputId}`"
      :rules="{ required: { allowFalse: !isAgreeRequired } }"
      ref="validationProvider"
      slim
    >
      <div class="cardsales-agreements__item">
        <div class="checkbox-wrapper">
          <input
            type="checkbox"
            :id="inputId"
            :disabled="disabled"
            :checked="isAgreed"
            :value="isAgreed"
            @input="toggle"
          >
          <label :for="inputId">
            <span>{{ title }}</span>
          </label>
        </div>
        <div class="cardsales-agreements__item__title">
          <!-- {{ title }} -->
        </div>
      </div>
      <p v-if="errors.length > 0" class="error-msg" v-inview:animate="'fadeIn'">
        {{ errors[0] }}
      </p>
    </ValidationProvider>
  </div>
</template>
<script>

export default {
  props: {
    inputId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    isAgreed: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isAgreeRequired: {
      type: Boolean,
      default: false
    },
    code: {
      type: String,
      default: null
    },
  },
  methods: {
    toggle() {
      if (this.disabled) {
        return
      }
      this.$emit('update:isAgreed', !this.isAgreed)
    }
  }
}
</script>
<style lang="scss" scoped>
  .cardsales-agreements {
    display: table-cell;
    float: left;
    margin: 8px 4px 8px 8px;
  }
  .error-msg {
    color: #ff1616;
    font-size: 13px;
    margin-top: 5px;
    animation-duration: .3s;
  }
  .cardsales-agreements__item {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    &__title {
      margin-left: 4px;
      font-size: 14px;
      letter-spacing: -0.5px;

      a {
        font-weight: 900;
        color: #1baaf1;
      }
    }

    $check-size: 26px;
    .checkbox-wrapper {
      // width: 26px;
      height: $check-size;

      input[type=checkbox] {
        display:none;
      }
      input[type=checkbox] + label {
        cursor: pointer;
        display: flex;
        padding-left: $check-size;
        // padding-bottom: 26px;
        background-repeat: no-repeat;
        background-image: url('../../../../assets/images/etc-etc-checkbox-sq.svg');
        -webkit-transition: background-image 0.3s ease-in-out;
                transition: background-image 0.3s ease-in-out;
      }
      input[type=checkbox]:checked + label {
        background-image: url('../../../../assets/images/etc-etc-checkbox-sq-dn.svg');
      }
      input[type=checkbox]:disabled + label {
        background-image: url('../../../../assets/images/etc-etc-checkbox-sq.svg');
      }
      input[type=checkbox] + label span {
        margin-left: 6px;
        line-height: $check-size;
        font-size: 14px;
      }
    }
  }
</style>
